import { FC, ReactNode } from 'react';
import { SecondarySpan, theme } from '@arnold/common';
import styled from '@emotion/styled/macro';
import { css } from '@emotion/react/macro';

type InfoBoxProps = {
  title?: string | null;
  children: ReactNode;
  showSeparator?: boolean;
  dataIcom?: string;
  dataCy?: string;
};

const Wrapper = styled.div<{ showSeparator?: boolean }>`
  ${({ showSeparator }) =>
    showSeparator &&
    css`
      border-left: solid ${theme.colors.borderMain.default} 1px;
      padding-left: ${theme.spacing.d};
      padding-right: ${theme.spacing.d};
    `}
  display: grid;
  font-size: 13px;
`;

export const InfoBox: FC<InfoBoxProps> = ({ showSeparator, title, children, dataIcom, dataCy }) => (
  <Wrapper showSeparator={showSeparator} data-cy={dataCy}>
    <SecondarySpan className="mb-1" data-icom={dataIcom}>
      {title}
    </SecondarySpan>
    {children}
  </Wrapper>
);
